import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useId, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { groupBy } from 'lodash';
import classNames from 'classnames';
import useScreen from 'hooks/useScreen';
import Placeholder from 'components/consumer/Placeholder';
import PDPActiveFabric from 'components/consumer/PDP/PDPActiveFabric';
import PDPDecideLaterPromo from 'components/consumer/PDP/PDPDecideLaterPromo';
import PDPUpholsterySortBy from 'components/consumer/PDP/PDPUpholsterySortBy';
import MaterialThumbnailGroup from 'components/consumer/MaterialThumbnailGroup';
import PDPUpholsteryFilters from 'components/consumer/PDP/PDPUpholsteryFilters';
import PDPFabricDetailSidebar from 'components/consumer/PDP/PDPFabricDetailSidebar';
import PDPFreeSwatchKitButton from 'components/consumer/PDP/PDPFreeSwatchKitButton';
import PDPOrderSwatchesSidebar from 'components/consumer/PDP/PDPOrderSwatchesSidebar';
import PDPUpholsteryColorFilters from 'components/consumer/PDP/PDPUpholsteryColorFilters';
import { PDP_CUSTOMIZE_TAB_ID, PDP_READYTOSHIP_TAB_ID, PDP_DECIDELATER_TAB_ID, FABRIC_PRODUCT_OPTION_ID, LEATHER_PRODUCT_OPTION_ID, GRADE_NUMERAL_BY_VALUE, PDP_NAMED_FILTERS, PANTONE_FABRIC_CONFIG } from 'commons/constants';
import { materialPropType, productFilterTypes } from '@/components/consumer/PDP/PDPTypes';
import useFabricDetails from 'data-hooks/useFabricDetails';
import { PRODUCT_CONFIGURATION_INTERACTION, trackProductConfigurationInteracted } from 'data-hooks/useEvents/pdpInteractionEvents';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
import usePdpIsModularBYOProduct from 'components/consumer/PDP/state/context/usePdpIsModularBYOProduct';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import CtaButton from 'components/essentials/Cta/CtaButton';
import IconFilter2 from 'components/icons/iconFilter2';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import { colorBrandDark, colorGray } from 'styles/layout/colors';
import useProjectResetConfig from 'data-hooks/useProjectResetConfig';
import MaterialThumbnailGroupPlaceholder from 'components/consumer/MaterialThumbnailGroup/MaterialThumbnailGroupPlaceholder';
import FlyoutContainer from '../../FlyoutContainer';
import PDPDecideLaterButton from '../PDPDecideLaterButton';
import PDPSelectUpholsteryDecideLater from './PDPSelectUpholsteryDecideLater';
const {
  pantoneFabricSkus
} = PANTONE_FABRIC_CONFIG;
const tiers = {
  1: {
    title: 'Tier 1',
    desc: 'Readily available fabrics that bring an eye-catching look to your piece at a great value.'
  },
  2: {
    title: 'Tier 2',
    desc: 'Kick things up a notch with fabrics that show off more rich colors, textures, and durability.'
  },
  3: {
    title: 'Tier 3',
    desc: 'Got an active home? Check out these fabrics that showcase top notch performance finishes while still looking stylish.'
  },
  4: {
    title: 'Tier 4',
    desc: 'As luxe as it gets, this tier includes our branded performance fabrics and stain resistant finish fabrics, ready to take on all life throws its way in sophisticated style.'
  }
};
const NUMBER_OF_SWATCHES_PER_ROW_ON_DESKTOP = 9;
const MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON = 3 * NUMBER_OF_SWATCHES_PER_ROW_ON_DESKTOP;
const LAYOUT_REVAMP_MOBILE_SWATCHES_BEFORE_SHOW_ALL_BUTTON = 3 * 6;
const SORT_BY_OPTIONS = {
  POPULARITY: 'popularity',
  FAMILY: 'family',
  TIER: 'tier'
};
const moveMaterialToSecondPosition = (materials, materialSku) => {
  if (materials?.length && materialSku && materials[0]?.sku !== materialSku) {
    const filteredMaterials = materials.filter(({
      sku
    }) => sku !== materialSku);
    const material = materials.find(({
      sku
    }) => sku === materialSku);
    const [firstMaterial, ...restMaterials] = filteredMaterials;
    return [firstMaterial, material, ...restMaterials];
  }
  return materials;
};
const PDPSelectUpholsteryUI = t0 => {
  const $ = _c(192);
  const {
    activeColorFilters,
    activeNamedFilters,
    allMaterialsLength,
    clearAllFilters,
    disabledMaterialIds,
    fabricFavProps,
    filterCounts: t1,
    flashSaleOptionIds: t2,
    isClearanceFabricAvailable,
    isEditOrder: t3,
    isSelectedOptionsQuickship,
    loading,
    materials,
    mode: t4,
    onMoreMaterialsClick,
    onOptionValueHover,
    onOptionValueSelection,
    selectedMaterial,
    selectedOptionsStockQty,
    toggleColorFilter,
    toggleNamedFilter,
    upholsteryFilteredEvent,
    upholsteryOptionId,
    upholsteryOptionName,
    isLayoutRevamp: t5
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const filterCounts = t6;
  let t7;
  if ($[2] !== t2) {
    t7 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const flashSaleOptionIds = t7;
  const isEditOrder = t3 === undefined ? false : t3;
  const mode = t4 === undefined ? "pdp" : t4;
  const isLayoutRevamp = t5 === undefined ? false : t5;
  const {
    isDesktop,
    isMobile
  } = useScreen();
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const [selectedSortOption, setSelectedSortOption] = useState(SORT_BY_OPTIONS.POPULARITY);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const [isOrderSwatchesSidebarOpen, setIsOrderSwatchesSidebarOpen] = useState(false);
  const hasActiveNamedFilters = activeNamedFilters.length > 0;
  const [isFilterChipsOpen, setIsFilterChipsOpen] = useState(hasActiveNamedFilters);
  const [hadActiveNamedFilters, setHadActiveNamedFilters] = useState(hasActiveNamedFilters);
  if (hasActiveNamedFilters !== hadActiveNamedFilters) {
    setHadActiveNamedFilters(hasActiveNamedFilters);
    if (hasActiveNamedFilters) {
      setIsFilterChipsOpen(true);
    }
  }
  const filterChipsId = useId();
  const [galleryType, setGalleryType] = useState("");
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {};
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const [sortByFlyOutContent, setSortByFlyOutContent] = useState(t8);
  const [isSortByFlyOutVisible, setIsSortByFlyOutVisible] = useState(false);
  const {
    data: t9
  } = useFabricDetails(selectedMaterial?.materialId);
  const {
    selectedFabric
  } = t9;
  const isTouchDevice = useIsTouchDevice();
  const isPdpMode = mode === "pdp";
  const isLayoutRevampPdp = isLayoutRevamp && isPdpMode;
  const isLeather = upholsteryOptionId === LEATHER_PRODUCT_OPTION_ID;
  const tierOrGradeLabel = isLeather ? "Grade" : "Tier";
  let t10;
  if ($[5] !== materials || $[6] !== selectedSortOption) {
    t10 = selectedSortOption === SORT_BY_OPTIONS.FAMILY ? groupBy(materials, "groupName") : {};
    $[5] = materials;
    $[6] = selectedSortOption;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const materialsGroupedByFamily = t10;
  let t11;
  if ($[8] !== isLeather || $[9] !== materials || $[10] !== selectedSortOption) {
    t11 = selectedSortOption === SORT_BY_OPTIONS.TIER ? groupBy(materials, isLeather ? "grade" : SORT_BY_OPTIONS.TIER) : {};
    $[8] = isLeather;
    $[9] = materials;
    $[10] = selectedSortOption;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const materialsGroupedByTier = t11;
  const isQuickview = mode === "quickview";
  const quickviewNumberOfFabricsToShow = isMobile ? 5 : 8;
  const limitNumberShownForQuickview = isQuickview && allMaterialsLength > quickviewNumberOfFabricsToShow;
  const {
    data: projectResetConfig
  } = useProjectResetConfig();
  let t12;
  if ($[12] !== projectResetConfig) {
    t12 = projectResetConfig ?? {};
    $[12] = projectResetConfig;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const {
    isProjectResetEnabled,
    projectResetNewFabricSkus
  } = t12;
  let t13;
  bb0: {
    let t14;
    if ($[14] !== isProjectResetEnabled || $[15] !== isQuickview || $[16] !== materials || $[17] !== projectResetNewFabricSkus?.[0]) {
      t14 = isQuickview ? moveMaterialToSecondPosition(materials, isProjectResetEnabled ? projectResetNewFabricSkus?.[0] : pantoneFabricSkus?.[0]) : materials;
      $[14] = isProjectResetEnabled;
      $[15] = isQuickview;
      $[16] = materials;
      $[17] = projectResetNewFabricSkus?.[0];
      $[18] = t14;
    } else {
      t14 = $[18];
    }
    const materialsPantoneFabricAsSecond = t14;
    if (limitNumberShownForQuickview) {
      let t15;
      if ($[19] !== materialsPantoneFabricAsSecond || $[20] !== quickviewNumberOfFabricsToShow) {
        t15 = materialsPantoneFabricAsSecond.slice(0, quickviewNumberOfFabricsToShow);
        $[19] = materialsPantoneFabricAsSecond;
        $[20] = quickviewNumberOfFabricsToShow;
        $[21] = t15;
      } else {
        t15 = $[21];
      }
      t13 = t15;
      break bb0;
    }
    t13 = materialsPantoneFabricAsSecond;
  }
  const ungroupedMaterialsArray = t13;
  const moreMaterialsCount = limitNumberShownForQuickview ? allMaterialsLength - quickviewNumberOfFabricsToShow : undefined;
  const ungroupedMaterialsLength = ungroupedMaterialsArray?.length ?? 0;
  const [hasShowAllFabricsButtonBeenClicked, setHasShowAllFabricsButtonBeenClicked] = useState(false);
  const isAllFabricsShown = !activeNamedFilters.length;
  const canCollapseFabrics = isLayoutRevampPdp || isDesktop;
  const minSwatchesToCollapse = isLayoutRevampPdp ? LAYOUT_REVAMP_MOBILE_SWATCHES_BEFORE_SHOW_ALL_BUTTON : MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON;
  const isCollapseMobileOnly = isLayoutRevampPdp && ungroupedMaterialsLength <= MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON;
  const showShowAllFabricsButton = canCollapseFabrics && isAllFabricsShown && !loading && !hasShowAllFabricsButtonBeenClicked && ungroupedMaterialsLength > minSwatchesToCollapse;
  let t14;
  if ($[22] !== showShowAllFabricsButton || $[23] !== ungroupedMaterialsArray) {
    t14 = showShowAllFabricsButton ? ungroupedMaterialsArray.slice(0, MAX_SWATCHES_BEFORE_SHOW_ALL_BUTTON) : ungroupedMaterialsArray;
    $[22] = showShowAllFabricsButton;
    $[23] = ungroupedMaterialsArray;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const ungroupedMaterialsToShow = t14;
  let t15;
  if ($[25] !== isTouchDevice) {
    t15 = upholsteryOptionNameVal => {
      const tapOrClick = isTouchDevice ? "tap" : "click";
      return upholsteryOptionNameVal === "Fabric" ? `Double-${tapOrClick} a fabric to add to your favorites` : upholsteryOptionNameVal === "Leather" ? `Double-${tapOrClick} a leather to add to your favorites` : "Double tap to favorite";
    };
    $[25] = isTouchDevice;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const getFabricFavInfoToShow = t15;
  const noActiveNamedFilters = !activeNamedFilters.length;
  const noActiveColorFilters = activeColorFilters.length === 0;
  const noActiveFilters = noActiveNamedFilters && noActiveColorFilters;
  const t16 = !noActiveFilters;
  let t17;
  if ($[27] !== noActiveFilters || $[28] !== t16) {
    t17 = classNames("text-xs font-bold p-[5px] underline", {
      "text-gray-light4 pointer-events-none": noActiveFilters,
      "text-red hover:text-red-dark": t16
    });
    $[27] = noActiveFilters;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== clearAllFilters || $[31] !== noActiveFilters) {
    t18 = () => {
      if (!noActiveFilters) {
        clearAllFilters();
        trackProductConfigurationInteracted(PRODUCT_CONFIGURATION_INTERACTION.FABRIC_FILTERS_CLEARED);
      }
    };
    $[30] = clearAllFilters;
    $[31] = noActiveFilters;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t17 || $[34] !== t18) {
    t19 = <button type="button" data-xc="PDPClearAllFiltersButton" className={t17} onClick={t18}>Clear All</button>;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  const clearAllFiltersButton = t19;
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = (content, isVisible) => {
      setSortByFlyOutContent(content);
      setIsSortByFlyOutVisible(isVisible);
    };
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  const onToggleFlyOut = t20;
  let t21;
  if ($[37] !== isSortByFlyOutVisible || $[38] !== sortByFlyOutContent) {
    t21 = isSortByFlyOutVisible && <FlyoutContainer top={sortByFlyOutContent.top > 300 ? sortByFlyOutContent.top - 300 : sortByFlyOutContent.top} title={sortByFlyOutContent.title} content={sortByFlyOutContent.content} subTitle={sortByFlyOutContent.subTitle} imageUrl={sortByFlyOutContent.imageUrl} titleInfo={sortByFlyOutContent.titleInfo} titleExtra={sortByFlyOutContent.titleExtra} subSubTitle={sortByFlyOutContent.subSubTitle} onClose={() => setIsSortByFlyOutVisible(false)} isOpen={isSortByFlyOutVisible} />;
    $[37] = isSortByFlyOutVisible;
    $[38] = sortByFlyOutContent;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  const flyoutContainerContent = t21;
  let t22;
  if ($[40] !== disabledMaterialIds || $[41] !== fabricFavProps || $[42] !== flashSaleOptionIds || $[43] !== isEditOrder || $[44] !== isLayoutRevampPdp || $[45] !== materialsGroupedByFamily || $[46] !== onOptionValueHover || $[47] !== onOptionValueSelection || $[48] !== pdpIsModularBYOProduct || $[49] !== selectedMaterial || $[50] !== upholsteryOptionId) {
    t22 = Object.keys(materialsGroupedByFamily).sort().map(groupName => <div key={groupName} className="mb-8"><div className="text-sm font-bold text-gray">{groupName}</div><MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isLayoutRevamp={isLayoutRevampPdp} isModularBundleProduct={pdpIsModularBYOProduct} materials={materialsGroupedByFamily[groupName]} onClick={onOptionValueSelection} onHover={onOptionValueHover} onToggleFlyOut={onToggleFlyOut} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} /></div>);
    $[40] = disabledMaterialIds;
    $[41] = fabricFavProps;
    $[42] = flashSaleOptionIds;
    $[43] = isEditOrder;
    $[44] = isLayoutRevampPdp;
    $[45] = materialsGroupedByFamily;
    $[46] = onOptionValueHover;
    $[47] = onOptionValueSelection;
    $[48] = pdpIsModularBYOProduct;
    $[49] = selectedMaterial;
    $[50] = upholsteryOptionId;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t22) {
    t23 = <div className="p-6 max-h-[472px] overflow-y-auto bg-gray-light9 border border-solid border-gray-light7">{t22}</div>;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  const sortByFamilyMaterialThumbnails = t23;
  const materialThumbnailVariant = mode === "quickview" ? "PDPSelectUpholsteryUI--quickview" : "PDPSelectUpholsteryUI";
  const t24 = !isLayoutRevampPdp;
  const t25 = mode === "quickview";
  let t26;
  if ($[54] !== t24 || $[55] !== t25) {
    t26 = classNames({
      "max-[1023px]:-ml-5 max-[1023px]:-mr-5 max-[1023px]:md:ml-[-3.333vw] max-[1023px]:md:mr-[-3.333vw]": t24,
      "max-[1023px]:md:!m-0": t25
    });
    $[54] = t24;
    $[55] = t25;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  const swatchGridBleedClasses = t26;
  let t27;
  if ($[57] !== disabledMaterialIds || $[58] !== fabricFavProps || $[59] !== flashSaleOptionIds || $[60] !== isEditOrder || $[61] !== isLayoutRevampPdp || $[62] !== isLeather || $[63] !== materialThumbnailVariant || $[64] !== materialsGroupedByTier || $[65] !== onOptionValueHover || $[66] !== onOptionValueSelection || $[67] !== pdpIsModularBYOProduct || $[68] !== selectedMaterial || $[69] !== swatchGridBleedClasses || $[70] !== tierOrGradeLabel || $[71] !== upholsteryOptionId) {
    t27 = Object.keys(materialsGroupedByTier).filter(_temp).sort(_temp2).map(tierId_0 => {
      const gradeNumeral = GRADE_NUMERAL_BY_VALUE[tierId_0] || String(tierId_0);
      const tierMeta = isLeather ? {
        title: `${tierOrGradeLabel} ${gradeNumeral}`,
        desc: ""
      } : tiers[tierId_0];
      return tierMeta ? <div key={tierId_0} className="mt-8"><div className="text-sm font-bold text-gray">{tierMeta.title}</div>{tierMeta.desc ? <div className="text-xs text-gray mb-[1.2rem]">{tierMeta.desc}</div> : <div className="mb-[1.2rem]" />}<div className={swatchGridBleedClasses}><MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isLayoutRevamp={isLayoutRevampPdp} isModularBundleProduct={pdpIsModularBYOProduct} materials={materialsGroupedByTier[tierId_0]} onClick={onOptionValueSelection} onHover={onOptionValueHover} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} variant={materialThumbnailVariant} /></div></div> : null;
    });
    $[57] = disabledMaterialIds;
    $[58] = fabricFavProps;
    $[59] = flashSaleOptionIds;
    $[60] = isEditOrder;
    $[61] = isLayoutRevampPdp;
    $[62] = isLeather;
    $[63] = materialThumbnailVariant;
    $[64] = materialsGroupedByTier;
    $[65] = onOptionValueHover;
    $[66] = onOptionValueSelection;
    $[67] = pdpIsModularBYOProduct;
    $[68] = selectedMaterial;
    $[69] = swatchGridBleedClasses;
    $[70] = tierOrGradeLabel;
    $[71] = upholsteryOptionId;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== t27) {
    t28 = <div>{t27}</div>;
    $[73] = t27;
    $[74] = t28;
  } else {
    t28 = $[74];
  }
  const sortByTierMaterialThumbnails = t28;
  let t29;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = () => {
      setGalleryType("");
      setSidebarOpen(false);
    };
    $[75] = t29;
  } else {
    t29 = $[75];
  }
  const onCloseCallback = t29;
  const showDesktopColorFilters = mode !== "quickview" && upholsteryOptionId === FABRIC_PRODUCT_OPTION_ID && !isMobile;
  let t30;
  if ($[76] !== activeColorFilters || $[77] !== activeNamedFilters || $[78] !== selectedSortOption || $[79] !== showDesktopColorFilters || $[80] !== toggleColorFilter || $[81] !== upholsteryFilteredEvent) {
    t30 = showDesktopColorFilters ? <div className="items-center flex justify-between w-full mb-4"><h4 className="text-base font-bold">Filter by color:</h4><PDPUpholsteryColorFilters activeColorFilters={activeColorFilters} toggleColorFilter={updatedColor => {
        toggleColorFilter(updatedColor);
        upholsteryFilteredEvent(activeNamedFilters, updatedColor, selectedSortOption);
      }} /></div> : <div />;
    $[76] = activeColorFilters;
    $[77] = activeNamedFilters;
    $[78] = selectedSortOption;
    $[79] = showDesktopColorFilters;
    $[80] = toggleColorFilter;
    $[81] = upholsteryFilteredEvent;
    $[82] = t30;
  } else {
    t30 = $[82];
  }
  const desktopColorFilterRow = t30;
  const showSortByRow = mode !== "quickview" && (upholsteryOptionId === FABRIC_PRODUCT_OPTION_ID || upholsteryOptionId === LEATHER_PRODUCT_OPTION_ID);
  let t31;
  if ($[83] !== activeColorFilters || $[84] !== activeNamedFilters || $[85] !== isLeather || $[86] !== selectedSortOption || $[87] !== showSortByRow || $[88] !== upholsteryFilteredEvent) {
    t31 = showSortByRow && <div className="hidden sm:block"><PDPUpholsterySortBy isLeather={isLeather} selectedOption={selectedSortOption} setSelectedOption={updatedSortOption => {
        setSelectedSortOption(updatedSortOption);
        upholsteryFilteredEvent(activeNamedFilters, activeColorFilters, updatedSortOption);
      }} /></div>;
    $[83] = activeColorFilters;
    $[84] = activeNamedFilters;
    $[85] = isLeather;
    $[86] = selectedSortOption;
    $[87] = showSortByRow;
    $[88] = upholsteryFilteredEvent;
    $[89] = t31;
  } else {
    t31 = $[89];
  }
  const sortByRow = t31;
  const isDecideLaterTab = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const showNamedFilters = !!isPdpMode && pdpSelectedCustomizerTab === PDP_CUSTOMIZE_TAB_ID && upholsteryOptionName !== "Leather";
  const isFilterChipsVisible = showNamedFilters && (!showSortByRow || isFilterChipsOpen);
  let t32;
  if ($[90] !== activeColorFilters || $[91] !== activeNamedFilters || $[92] !== filterChipsId || $[93] !== isDecideLaterTab || $[94] !== isFilterChipsVisible || $[95] !== isLeather || $[96] !== selectedSortOption || $[97] !== showNamedFilters || $[98] !== showSortByRow || $[99] !== upholsteryFilteredEvent) {
    t32 = showSortByRow && !isDecideLaterTab && <div className="flex items-center gap-3 mb-4"><div className="flex-1 min-w-0"><PDPUpholsterySortBy isLeather={isLeather} selectedOption={selectedSortOption} setSelectedOption={updatedSortOption_0 => {
          setSelectedSortOption(updatedSortOption_0);
          upholsteryFilteredEvent(activeNamedFilters, activeColorFilters, updatedSortOption_0);
        }} /></div>{showNamedFilters && <button type="button" data-xc="PDPUpholsteryFilterToggle" aria-controls={isFilterChipsVisible ? filterChipsId : undefined} aria-expanded={isFilterChipsVisible} className="flex items-center justify-center shrink-0 w-10 h-10 bg-white border border-solid border-gray-light4 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand" onClick={() => {
        setIsFilterChipsOpen(_temp3);
        if (!isFilterChipsVisible) {
          trackProductConfigurationInteracted(PRODUCT_CONFIGURATION_INTERACTION.FABRIC_FILTERS_OPENED);
        }
      }}><VisuallyHidden>{activeNamedFilters.length ? `Filter fabrics, ${activeNamedFilters.length} active` : "Filter fabrics"}</VisuallyHidden><IconFilter2 aria-hidden="true" color={isFilterChipsVisible || activeNamedFilters.length ? colorBrandDark : colorGray} /></button>}</div>;
    $[90] = activeColorFilters;
    $[91] = activeNamedFilters;
    $[92] = filterChipsId;
    $[93] = isDecideLaterTab;
    $[94] = isFilterChipsVisible;
    $[95] = isLeather;
    $[96] = selectedSortOption;
    $[97] = showNamedFilters;
    $[98] = showSortByRow;
    $[99] = upholsteryFilteredEvent;
    $[100] = t32;
  } else {
    t32 = $[100];
  }
  const layoutRevampSortByRow = t32;
  let t33;
  if ($[101] !== activeColorFilters || $[102] !== selectedSortOption || $[103] !== toggleNamedFilter || $[104] !== upholsteryFilteredEvent) {
    t33 = updatedFilterType => {
      toggleNamedFilter(updatedFilterType);
      upholsteryFilteredEvent(updatedFilterType, activeColorFilters, selectedSortOption);
    };
    $[101] = activeColorFilters;
    $[102] = selectedSortOption;
    $[103] = toggleNamedFilter;
    $[104] = upholsteryFilteredEvent;
    $[105] = t33;
  } else {
    t33 = $[105];
  }
  const t34 = !!fabricFavProps.actions.setOptionAsFav;
  const t35 = activeNamedFilters.length === 1 && activeNamedFilters[0] === PDP_NAMED_FILTERS.FAVORITES ? getFabricFavInfoToShow(upholsteryOptionName) : "";
  let t36;
  if ($[106] !== activeNamedFilters || $[107] !== clearAllFiltersButton || $[108] !== filterCounts || $[109] !== isClearanceFabricAvailable || $[110] !== loading || $[111] !== t33 || $[112] !== t34 || $[113] !== t35) {
    t36 = <PDPUpholsteryFilters clearAllFiltersButton={clearAllFiltersButton} filtersCollectionVisible={activeNamedFilters} setFiltersCollectionVisible={t33} filterCounts={filterCounts} loading={loading} showFabricFavs={t34} isClearanceFabricAvailable={isClearanceFabricAvailable} fabricFavInfoToShow={t35} variant="PDPSelectUpholstery" />;
    $[106] = activeNamedFilters;
    $[107] = clearAllFiltersButton;
    $[108] = filterCounts;
    $[109] = isClearanceFabricAvailable;
    $[110] = loading;
    $[111] = t33;
    $[112] = t34;
    $[113] = t35;
    $[114] = t36;
  } else {
    t36 = $[114];
  }
  const namedFilters = t36;
  const showSwatchKitButton = !!isPdpMode && (pdpSelectedCustomizerTab !== PDP_READYTOSHIP_TAB_ID || isLayoutRevampPdp) && !isEditOrder;
  const showShowLessFabricsButton = isLayoutRevampPdp && isAllFabricsShown && !loading && hasShowAllFabricsButtonBeenClicked && ungroupedMaterialsLength > minSwatchesToCollapse;
  let t37;
  if ($[115] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = () => {
      setGalleryType("FabricMultiImg");
      setSidebarOpen(true);
    };
    $[115] = t37;
  } else {
    t37 = $[115];
  }
  const openFabricDetails = t37;
  let t38;
  if ($[116] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = () => {
      setIsOrderSwatchesSidebarOpen(true);
      trackProductConfigurationInteracted(PRODUCT_CONFIGURATION_INTERACTION.FREE_SWATCHES_OPENED);
    };
    $[116] = t38;
  } else {
    t38 = $[116];
  }
  const openOrderSwatchesSidebar = t38;
  let t39;
  let t40;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = () => {
      setIsOrderSwatchesSidebarOpen(false);
    };
    t40 = () => {
      setIsOrderSwatchesSidebarOpen(false);
    };
    $[117] = t39;
    $[118] = t40;
  } else {
    t39 = $[117];
    t40 = $[118];
  }
  let t41;
  if ($[119] !== isOrderSwatchesSidebarOpen) {
    t41 = <PDPOrderSwatchesSidebar show={isOrderSwatchesSidebarOpen} onClose={t39} closeSlidePanel={t40} />;
    $[119] = isOrderSwatchesSidebarOpen;
    $[120] = t41;
  } else {
    t41 = $[120];
  }
  const orderSwatchesSidebar = t41;
  const t42 = mode !== "quickview";
  let t43;
  if ($[121] !== t42) {
    t43 = classNames("relative", {
      "[border-bottom:1px_solid_#e5e5e5] mb-2 pb-8": t42
    });
    $[121] = t42;
    $[122] = t43;
  } else {
    t43 = $[122];
  }
  let t44;
  if ($[123] !== filterChipsId || $[124] !== isEditOrder || $[125] !== isFilterChipsVisible || $[126] !== isLayoutRevampPdp || $[127] !== layoutRevampSortByRow || $[128] !== namedFilters) {
    t44 = isLayoutRevampPdp && <>{layoutRevampSortByRow}{isFilterChipsVisible && <div id={filterChipsId} className="mb-4 max-[1023px]:-ml-10 max-[1023px]:-mr-5">{namedFilters}</div>}<PDPDecideLaterButton className="mb-4" isEditOrder={isEditOrder} /></>;
    $[123] = filterChipsId;
    $[124] = isEditOrder;
    $[125] = isFilterChipsVisible;
    $[126] = isLayoutRevampPdp;
    $[127] = layoutRevampSortByRow;
    $[128] = namedFilters;
    $[129] = t44;
  } else {
    t44 = $[129];
  }
  let t45;
  if ($[130] !== isDecideLaterTab || $[131] !== isLayoutRevampPdp) {
    t45 = !isLayoutRevampPdp && isDecideLaterTab ? <PDPSelectUpholsteryDecideLater /> : null;
    $[130] = isDecideLaterTab;
    $[131] = isLayoutRevampPdp;
    $[132] = t45;
  } else {
    t45 = $[132];
  }
  const t46 = !isLayoutRevampPdp && desktopColorFilterRow;
  let t47;
  if ($[133] !== activeColorFilters || $[134] !== activeNamedFilters || $[135] !== clearAllFiltersButton || $[136] !== desktopColorFilterRow || $[137] !== disabledMaterialIds || $[138] !== fabricFavProps || $[139] !== flashSaleOptionIds || $[140] !== flyoutContainerContent || $[141] !== getFabricFavInfoToShow || $[142] !== isCollapseMobileOnly || $[143] !== isDesktop || $[144] !== isEditOrder || $[145] !== isLayoutRevampPdp || $[146] !== isMobile || $[147] !== isPdpMode || $[148] !== isSelectedOptionsQuickship || $[149] !== loading || $[150] !== materialThumbnailVariant || $[151] !== mode || $[152] !== moreMaterialsCount || $[153] !== namedFilters || $[154] !== onMoreMaterialsClick || $[155] !== onOptionValueHover || $[156] !== onOptionValueSelection || $[157] !== orderSwatchesSidebar || $[158] !== pdpIsModularBYOProduct || $[159] !== pdpSelectedCustomizerTab || $[160] !== selectedFabric || $[161] !== selectedMaterial || $[162] !== selectedOptionsStockQty || $[163] !== selectedSortOption || $[164] !== showShowAllFabricsButton || $[165] !== showShowLessFabricsButton || $[166] !== showSwatchKitButton || $[167] !== sortByFamilyMaterialThumbnails || $[168] !== sortByRow || $[169] !== sortByTierMaterialThumbnails || $[170] !== swatchGridBleedClasses || $[171] !== toggleColorFilter || $[172] !== ungroupedMaterialsArray || $[173] !== ungroupedMaterialsToShow || $[174] !== upholsteryFilteredEvent || $[175] !== upholsteryOptionId || $[176] !== upholsteryOptionName) {
    t47 = pdpSelectedCustomizerTab === PDP_CUSTOMIZE_TAB_ID || pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID ? <div>{!!isPdpMode && pdpSelectedCustomizerTab === PDP_CUSTOMIZE_TAB_ID ? upholsteryOptionName === "Leather" ? <div className={classNames("text-sm mx-0 font-bold", {
        "-mt-8 mb-8": !isLayoutRevampPdp,
        "mb-4": isLayoutRevampPdp
      })}>{getFabricFavInfoToShow("Leather")}</div> : <>{isMobile && <div className="flex justify-between my-1"><h4 className="text-base font-bold">Filter by color</h4>{clearAllFiltersButton}</div>}<div className="mt-0 mx-0 space-y-2 max-[1023px]:-ml-10 max-[1023px]:-mr-5 [&::-webkit-scrollbar]:max-[1023px]:hidden max-[1023px]:pb-6">{isMobile && <PDPUpholsteryColorFilters activeColorFilters={activeColorFilters} showRowInMobile={true} toggleColorFilter={color => {
            toggleColorFilter(color);
            upholsteryFilteredEvent(activeNamedFilters, color, selectedSortOption);
          }} showMobileColorFilter={true} />}{!isLayoutRevampPdp && <div>{namedFilters}</div>}{!loading && ungroupedMaterialsArray.length === 0 && <span className="text-xs font-bold text-gray">Try removing a filter to see more fabric options</span>}</div></> : <div />}{!isLayoutRevampPdp && sortByRow}{isLayoutRevampPdp && desktopColorFilterRow}<div className="flex flex-row justify-between"><PDPActiveFabric isEditOrder={isEditOrder} isModularBundleProduct={pdpIsModularBYOProduct} isSelectedOptionsQuickship={pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID && isSelectedOptionsQuickship} loading={loading} onClick={isLayoutRevampPdp ? undefined : openFabricDetails} selectedOption={selectedMaterial} selectedOptionsStockQty={selectedOptionsStockQty} size={mode === "quickview" ? "xs" : undefined} showInfoIcon={!isLayoutRevampPdp && !!selectedFabric} showThumbnail={!isLayoutRevampPdp} />{showSwatchKitButton && !isLayoutRevampPdp ? loading ? <Placeholder type="rect" loading={true} style={{
          height: "43px",
          width: "152px",
          borderRadius: "43px"
        }} /> : <div className="mb-2"><PDPFreeSwatchKitButton styling="rainbow-button" onClick={openOrderSwatchesSidebar} />{orderSwatchesSidebar}</div> : isLayoutRevampPdp && !loading && !!selectedFabric ? <button type="button" data-xc="PDPFabricDetailsLink" className="text-xs font-bold p-[5px] underline text-brand hover:text-brand-dark mb-2 lg:mb-1.5" onClick={openFabricDetails}>Fabric Details</button> : <div />}</div>{selectedSortOption === SORT_BY_OPTIONS.FAMILY ? <>{flyoutContainerContent}{sortByFamilyMaterialThumbnails}</> : selectedSortOption === SORT_BY_OPTIONS.TIER ? sortByTierMaterialThumbnails : <div data-xc="PDPFabricSwatches" className={swatchGridBleedClasses}>{loading ? <MaterialThumbnailGroupPlaceholder isLayoutRevamp={isLayoutRevampPdp} variant={materialThumbnailVariant} /> : <MaterialThumbnailGroup disabledMaterialIds={disabledMaterialIds} enableFlyout={mode === "pdp"} fabricFavProps={fabricFavProps} flashSaleOptionIds={flashSaleOptionIds} isEditOrder={isEditOrder} isLayoutRevamp={isLayoutRevampPdp} isModularBundleProduct={pdpIsModularBYOProduct} materials={ungroupedMaterialsToShow} mobileMaterialsLimit={isLayoutRevampPdp && showShowAllFabricsButton ? LAYOUT_REVAMP_MOBILE_SWATCHES_BEFORE_SHOW_ALL_BUTTON : undefined} moreMaterialsCount={moreMaterialsCount} onClick={onOptionValueSelection} onHover={onOptionValueHover} onMoreMaterialsClick={onMoreMaterialsClick} optionId={upholsteryOptionId} selectedMaterial={selectedMaterial} showMoreMaterialsOnDesktop={mode === "quickview"} variant={materialThumbnailVariant} />}{showShowAllFabricsButton && <div className={classNames("relative pt-6 mt-[-52px] bg-white bg-opacity-70", {
          "md:hidden": isCollapseMobileOnly,
          "max-[767px]:mt-0 max-[767px]:pt-4": isLayoutRevampPdp
        })}><div className="bg-white px-[6px]"><CtaButton block={true} color="brand" onClick={() => {
              setHasShowAllFabricsButtonBeenClicked(true);
              trackProductConfigurationInteracted(PRODUCT_CONFIGURATION_INTERACTION.FABRICS_EXPANDED);
            }} spacing="sm" styling="outline-button">Show All Fabrics</CtaButton></div></div>}{showShowLessFabricsButton && <div className={classNames("px-[6px] pt-4", {
          "md:hidden": isCollapseMobileOnly
        })}><CtaButton block={true} color="brand" onClick={() => {
            setHasShowAllFabricsButtonBeenClicked(false);
            trackProductConfigurationInteracted(PRODUCT_CONFIGURATION_INTERACTION.FABRICS_COLLAPSED);
          }} spacing="sm" styling="outline-button">Show Less Fabrics</CtaButton></div>}</div>}{isLayoutRevampPdp && showSwatchKitButton && <div className="mt-3 px-[6px]"><PDPFreeSwatchKitButton block={true} styling="outline-button" onClick={openOrderSwatchesSidebar} />{orderSwatchesSidebar}</div>}{!isLayoutRevampPdp && !!isPdpMode && pdpSelectedCustomizerTab !== PDP_READYTOSHIP_TAB_ID && !isEditOrder && isDesktop ? <div className="mt-4 mx-0 mb-0"><PDPDecideLaterPromo /></div> : <div />}</div> : <div />;
    $[133] = activeColorFilters;
    $[134] = activeNamedFilters;
    $[135] = clearAllFiltersButton;
    $[136] = desktopColorFilterRow;
    $[137] = disabledMaterialIds;
    $[138] = fabricFavProps;
    $[139] = flashSaleOptionIds;
    $[140] = flyoutContainerContent;
    $[141] = getFabricFavInfoToShow;
    $[142] = isCollapseMobileOnly;
    $[143] = isDesktop;
    $[144] = isEditOrder;
    $[145] = isLayoutRevampPdp;
    $[146] = isMobile;
    $[147] = isPdpMode;
    $[148] = isSelectedOptionsQuickship;
    $[149] = loading;
    $[150] = materialThumbnailVariant;
    $[151] = mode;
    $[152] = moreMaterialsCount;
    $[153] = namedFilters;
    $[154] = onMoreMaterialsClick;
    $[155] = onOptionValueHover;
    $[156] = onOptionValueSelection;
    $[157] = orderSwatchesSidebar;
    $[158] = pdpIsModularBYOProduct;
    $[159] = pdpSelectedCustomizerTab;
    $[160] = selectedFabric;
    $[161] = selectedMaterial;
    $[162] = selectedOptionsStockQty;
    $[163] = selectedSortOption;
    $[164] = showShowAllFabricsButton;
    $[165] = showShowLessFabricsButton;
    $[166] = showSwatchKitButton;
    $[167] = sortByFamilyMaterialThumbnails;
    $[168] = sortByRow;
    $[169] = sortByTierMaterialThumbnails;
    $[170] = swatchGridBleedClasses;
    $[171] = toggleColorFilter;
    $[172] = ungroupedMaterialsArray;
    $[173] = ungroupedMaterialsToShow;
    $[174] = upholsteryFilteredEvent;
    $[175] = upholsteryOptionId;
    $[176] = upholsteryOptionName;
    $[177] = t47;
  } else {
    t47 = $[177];
  }
  let t48;
  if ($[178] !== t44 || $[179] !== t45 || $[180] !== t46 || $[181] !== t47) {
    t48 = <div>{t44}{t45}{t46}{t47}</div>;
    $[178] = t44;
    $[179] = t45;
    $[180] = t46;
    $[181] = t47;
    $[182] = t48;
  } else {
    t48 = $[182];
  }
  const t49 = !!selectedMaterial?.materialId && isSidebarOpen;
  const t50 = selectedMaterial?.materialId;
  let t51;
  if ($[183] !== galleryType || $[184] !== mode || $[185] !== t49 || $[186] !== t50) {
    t51 = <PDPFabricDetailSidebar isOpen={t49} onClose={onCloseCallback} fabricId={t50} mode={mode} galleryType={galleryType} mobileHideHeader={true} />;
    $[183] = galleryType;
    $[184] = mode;
    $[185] = t49;
    $[186] = t50;
    $[187] = t51;
  } else {
    t51 = $[187];
  }
  let t52;
  if ($[188] !== t43 || $[189] !== t48 || $[190] !== t51) {
    t52 = <div className={t43}>{t48}{t51}</div>;
    $[188] = t43;
    $[189] = t48;
    $[190] = t51;
    $[191] = t52;
  } else {
    t52 = $[191];
  }
  return t52;
};
PDPSelectUpholsteryUI.propTypes = {
  activeNamedFilters: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  allMaterialsLength: PropTypes.number,
  disabledMaterialIds: PropTypes.arrayOf(PropTypes.number),
  fabricFavProps: PropTypes.object,
  filterCounts: productFilterTypes,
  flashSaleOptionIds: PropTypes.arrayOf(PropTypes.number),
  isClearanceFabricAvailable: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isSelectedOptionsQuickship: PropTypes.bool,
  loading: PropTypes.bool,
  materials: PropTypes.arrayOf(materialPropType),
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  onOptionValueHover: PropTypes.func,
  onOptionValueSelection: PropTypes.func,
  activeColorFilters: PropTypes.array,
  selectedMaterial: materialPropType,
  selectedOptionsStockQty: PropTypes.number,
  toggleColorFilter: PropTypes.func,
  toggleNamedFilter: PropTypes.func,
  upholsteryFilteredEvent: PropTypes.func,
  upholsteryOptionId: PropTypes.number,
  upholsteryOptionName: PropTypes.string,
  // CON-8777 test variant reorders the filter, sort and swatch-kit rows
  isLayoutRevamp: PropTypes.bool
};
export default PDPSelectUpholsteryUI;
function _temp(tierId) {
  return Number(tierId) > 0;
}
function _temp2(a, b) {
  return Number(a) - Number(b);
}
function _temp3(isOpen) {
  return !isOpen;
}